import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { AtlassianLogo } from '@atlaskit/logo';
import { B400, B200 } from '@atlaskit/theme/colors';
import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { CheckEmailPageLayoutPropsType } from '../../../../../model/check-email-page';
import { InboxImage, ResendEmailButton } from '../components';
import { messages } from '../messages';
import { Bold, Group, Header, ImageWrapper, Wrapper } from '../styled';

export function LayoutDefault({
  email,
  shouldEnable,
  baseUrl,
  checkEmailAnalyticsService
}: CheckEmailPageLayoutPropsType) {
  const { createAnalyticsEvent } = useAnalyticsEvents();

  let pageContent = (
    <>
      <div>
        <FormattedMessage {...messages.noResendNoEmail} />
        {
          ' ' /* without this single space, these two strings sit too close together. */
        }
        <span
          className="contactLink"
          onClick={() =>
            checkEmailAnalyticsService.contactLinkAnalytics(
              createAnalyticsEvent
            )
          }
        >
          <FormattedHTMLMessage {...messages.noResendContactUsHtml} />
        </span>
      </div>
      <FormattedMessage {...messages.noResendEmailConfirmation} />
    </>
  );

  if (shouldEnable) {
    pageContent = (
      <>
        <Group>
          <FormattedMessage {...messages.resendEmailLineOne} />
          <Bold>{email}</Bold>
          <FormattedMessage {...messages.resendEmailLineTwo} />
        </Group>
        <Group>
          <FormattedMessage {...messages.resendEmailCheckSpam} />
        </Group>
        <Group>
          <ResendEmailButton
            baseUrl={baseUrl}
            checkEmailAnalyticsService={checkEmailAnalyticsService}
          />
        </Group>
        <Group>
          <Bold>
            <FormattedMessage {...messages.resendEmailChangeEmail} />
          </Bold>
          <a
            href="#"
            onClick={(e) =>
              checkEmailAnalyticsService.navigateBack(e, createAnalyticsEvent)
            }
          >
            <FormattedMessage {...messages.resendEmailChangeEmailAction} />
          </a>
        </Group>
      </>
    );
  }

  return (
    <Wrapper>
      <AtlassianLogo
        size="xlarge"
        textColor={B400}
        iconColor={B200}
        iconGradientStart={B400}
        iconGradientStop={B200}
      />
      <Header>
        <FormattedMessage {...messages.header} />
      </Header>
      <ImageWrapper>
        <InboxImage />
      </ImageWrapper>
      {pageContent}
    </Wrapper>
  );
}
